var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIntroduce3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_290_2773)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.3164 25.3812C10.3164 17.0969 17.0321 10.3812 25.3164 10.3812H55.3164C63.6007 10.3812 70.3164 17.0969 70.3164 25.3812V70.3812H25.3164C17.0321 70.3812 10.3164 63.6654 10.3164 55.3812V25.3812Z",
    fill: "#FF5530"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.574 26.5542C41.2573 26.0204 39.7844 26.0204 38.4677 26.5542L35.2765 27.8482L49.2537 33.2834L54.1702 31.3847C53.9687 31.2175 53.7426 31.0823 53.4999 30.984L42.574 26.5542ZM55.0925 33.3709L41.6138 38.5788V54.4954C41.9402 54.4298 42.2607 54.3322 42.574 54.2054L53.4999 49.7756C53.9705 49.585 54.3735 49.2582 54.6572 48.8372C54.941 48.4161 55.0926 47.9199 55.0925 47.4121V33.3723V33.3709ZM39.428 54.4954V38.5788L25.9492 33.3709V47.4136C25.9495 47.9211 26.1012 48.417 26.385 48.8378C26.6687 49.2586 27.0715 49.5851 27.5419 49.7756L38.4677 54.2054C38.781 54.3322 39.1016 54.4284 39.428 54.4969V54.4954ZM26.8716 31.3847L40.5209 36.6582L46.2286 34.4521L32.3229 29.046L27.5419 30.984C27.2942 31.0846 27.0698 31.2201 26.8716 31.3847Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_290_2773",
    x: 0.316406,
    y: 0.381165,
    width: 80,
    height: 80,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.36 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "darken",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_290_2773"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_290_2773",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntroduce3);
export default __webpack_public_path__ + "static/media/introduce3.d80cfcb08fb3d2196354f3ad86486b26.svg";
export { ForwardRef as ReactComponent };